import React from 'react';
import ReviewCard from '../feed/ReviewCard';

function SavedView({
  savedRestaurants,
  onPhotoClick,
  onSaveReview,
  onUnsaveReview,
  onViewCreator,
  onUpgrade
}) {
  return (
    <div className="space-y-6" data-testid="saved-view">
      <h2 className="text-2xl font-heading font-bold">Saved Spots</h2>
      {savedRestaurants.length === 0 ? (
        <div className="text-center py-16">
          <p className="text-xl text-gray-500">No saved restaurants yet 📌</p>
        </div>
      ) : (
        savedRestaurants.map(saved => (
          <ReviewCard
            key={saved.saved_id}
            review={saved.review}
            onPhotoClick={(index) => onPhotoClick(saved.review, index)}
            onSave={() => onSaveReview(saved.review.review_id, saved.review.restaurant.name)}
            onUnsave={() => onUnsaveReview(saved.review.review_id, saved.review.restaurant.name)}
            isSaved={true}
            onViewCreator={onViewCreator}
            onUpgrade={(creatorId, creatorName) => onUpgrade(creatorId, creatorName, 7.0)}
          />
        ))
      )}
    </div>
  );
}

export default SavedView;
